// extracted by mini-css-extract-plugin
module.exports =  {"gpt-banner":"_93444fe79c--gpt-banner--X0jVy","text":"_93444fe79c--text--ynrxi","description":"_93444fe79c--description--NIqpe"};